module.exports = {
    RECEIVE_ALL_WATERSHEDS: 'RECEIVE_ALL_WATERSHEDS',
    RECEIVE_WATERSHED: 'RECEIVE_WATERSHED',
    STATIONS_WITH_WATERSHED: 'STATIONS_WITH_WATERSHED',
    RESET_STATIONS_WITH_WATERSHED: 'RESET_STATIONS_WITH_WATERSHED',
    RESET_WATERSHED: 'RESET_WATERSHED',
    RECEIVE_STATION_WATERSHED: 'RECEIVE_STATION_WATERSHED',
    RECEIVE_STATION_WATERSHEDS: 'RECEIVE_STATION_WATERSHEDS',
}